module.exports = __webpack_public_path__ + "media/images/spinner-67a8c3692d1c9a7e3f446047a5896103.svg";